// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27%3E%3Cpath fill=%27none%27 stroke=%27%2364748b%27 stroke-width=%271.6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 d=%27M1 1.5 6 6.5 11 1.5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wrapper/overlay que muestra el wizard sobre el Home.
   Es scrolleable (por eso overrideamos el overflow:hidden del body). */
.wizard-modal {
  position: fixed;
  inset: 0;
  z-index: 1500;
  background: rgba(0, 0, 0, 0.35);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

/* Ruta /property-form — card centrada en pantalla */
.property-form-page {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  padding: 24px max(28px, 4vw);
  background:
    radial-gradient(ellipse 80% 50% at 50% -10%, rgba(250, 115, 23, 0.14), transparent 55%),
    linear-gradient(165deg, #fff7ed 0%, #f3f4f6 48%, #eef2f7 100%);
  box-sizing: border-box;
}

.property-form-page__logo {
  height: 58px;
  width: auto;
  flex-shrink: 0;
}

/* Estilos para el asistente de propiedades
   Radio unificado con CTA landing/dashboard (12px). */
.property-wizard-container {
  --app-radius: 12px;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 22px 24px;
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(18px) saturate(1.2);
  -webkit-backdrop-filter: blur(18px) saturate(1.2);
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: var(--app-radius);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.8) inset,
    0 10px 36px rgba(15, 23, 42, 0.08);
  font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

.property-wizard-container .wizard-step h2,
.property-wizard-container .wizard-step h3,
.property-wizard-container .wizard-step .subtitle,
.property-wizard-container .wizard-step__title,
.property-wizard-container .wizard-step__subtitle {
  text-align: center;
}

.wizard-header {
  margin-bottom: 22px;
}

.progress-bar {
  height: 6px;
  background: rgba(254, 215, 170, 0.55);
  border-radius: var(--app-radius, 12px);
  overflow: hidden;
  margin-bottom: 10px;
}

.progress {
  height: 100%;
  background: linear-gradient(90deg, #fa7317, #fb923c);
  border-radius: var(--app-radius, 12px);
  transition: width 0.35s ease;
  min-width: 0;
}

.step-indicator {
  text-align: center;
  color: #c2410c;
  font-weight: 700;
  font-size: 0.78rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.wizard-help-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  margin: 0;
  padding: 0.35rem 0.5rem;
  border: none;
  background: transparent;
  color: #c2410c;
  font: inherit;
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-color: rgba(194, 65, 12, 0.35);
}

.wizard-help-trigger:hover {
  color: #9a3412;
  text-decoration-color: rgba(154, 52, 18, 0.55);
}

.wizard-help-trigger .pi {
  font-size: 0.95rem;
}

.property-form-page > .wizard-help-trigger {
  flex-shrink: 0;
}

.wizard-modal > .wizard-help-trigger {
  margin-top: 0.75rem;
}

/* Drawer — ayuda del paso (Paso 1) */
.wizard-help-drawer.p-sidebar {
  width: min(400px, 100vw);
  background: #fff;
  box-shadow: -12px 0 36px rgba(15, 23, 42, 0.12);
}

.wizard-help-drawer .p-sidebar-header {
  padding: 0.85rem 1rem 0;
  justify-content: flex-end;
}

.wizard-help-drawer .p-sidebar-content {
  padding: 0 1.25rem 1.5rem;
}

.wizard-help-drawer__body {
  text-align: left;
}

.wizard-help-drawer__header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.wizard-help-drawer__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  border-radius: var(--app-radius, 12px);
  color: #c2410c;
  background: #fff7ed;
  border: 1px solid #fed7aa;
}

.wizard-help-drawer__eyebrow {
  margin: 0 0 0.1rem;
  color: #c2410c;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.wizard-help-drawer__title {
  margin: 0;
  color: #1f2937;
  font-size: 1.15rem;
  line-height: 1.25;
}

.wizard-help-drawer__lead {
  margin: 0 0 1rem;
  color: #374151;
  font-size: 0.95rem;
  line-height: 1.5;
}

.wizard-help-drawer__steps {
  margin: 0;
  padding-left: 1.2rem;
  color: #4b5563;
  font-size: 0.92rem;
  line-height: 1.45;
}

.wizard-help-drawer__steps li + li {
  margin-top: 0.45rem;
}

.wizard-help-drawer__tip {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  margin-top: 1.15rem;
  padding-top: 1rem;
  border-top: 1px solid #fee2c5;
  color: #0f766e;
  font-size: 0.88rem;
  line-height: 1.4;
}

.wizard-help-drawer__tip .pi {
  margin-top: 0.1rem;
  flex-shrink: 0;
}

@media (max-width: 520px) {
  .wizard-help-drawer.p-sidebar {
    width: 100vw;
  }
}

.wizard-step h2 {
  color: #0f172a;
  font-size: clamp(1.35rem, 2.4vw, 1.75rem);
  font-weight: 750;
  letter-spacing: -0.02em;
  line-height: 1.2;
  margin: 0 0 0.4rem;
}

.subtitle {
  color: #64748b;
  margin: 0 0 1.5rem;
  font-size: 0.98rem;
  line-height: 1.45;
}

/* Paso 1 — jerarquía y layout */
.wizard-step__intro {
  margin-bottom: 1.5rem;
}

.wizard-step__title {
  margin: 0 0 0.4rem;
  color: #0f172a;
  font-size: clamp(1.4rem, 2.6vw, 1.85rem);
  font-weight: 750;
  letter-spacing: -0.025em;
  line-height: 1.18;
}

.wizard-step__subtitle {
  margin: 0 auto;
  max-width: 34rem;
  color: #64748b;
  font-size: 0.98rem;
  line-height: 1.45;
  font-weight: 400;
}

.wizard-step__subtitle strong {
  color: #0f172a;
  font-weight: 650;
}

.wizard-step--zone .wizard-step__subtitle {
  max-width: 42rem;
}

.wizard-step--location .wizard-step__body {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
}

/* Paso 1 en /property-form: el card es más ancho y el contenido usa las dos columnas. */
.property-form-page .property-wizard-container {
  max-width: 1480px;
}

.property-form-page .wizard-step--location .wizard-step__body {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
}

.wizard-step--location .wizard-field {
  width: 100%;
  text-align: left;
}

.custom-searchbox-wrapper {
  width: 100%;
  position: relative !important;
  left: auto !important;
  top: auto !important;
  transform: none !important;
  display: flex;
  justify-content: stretch;
}

.custom-searchbox-wrapper * {
  position: relative !important;
  left: auto !important;
  top: auto !important;
  transform: none !important;
}

.custom-searchbox-wrapper #pac-input {
  width: 100%;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid rgba(250, 115, 23, 0.16);
  background: #fff;
  color: #0f172a;
  font: inherit;
  font-size: 16px;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.custom-searchbox-wrapper #pac-input:focus {
  outline: none;
  border-color: #fa7317;
  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.15);
}

.operation-options {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.65rem;
}

.operation-option {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(250, 115, 23, 0.16);
  background: linear-gradient(155deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 247, 237, 0.7) 100%);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);
  color: #334155;
  font-size: 0.95rem;
  font-weight: 650;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.operation-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.operation-option:hover {
  border-color: rgba(250, 115, 23, 0.45);
}

.operation-option--active {
  border-color: #fa7317;
  background: rgba(250, 115, 23, 0.1);
  color: #c2410c;
  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.12);
}

.input-group {
  margin-bottom: 20px;
}

.input-group label {
  display: block;
  margin-bottom: 8px;
  color: #495057;
  font-weight: 500;
}

.wizard-input {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid rgba(250, 115, 23, 0.16);
  border-radius: 12px;
  font: inherit;
  font-size: 16px;
  color: #0f172a;
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
}

.wizard-select {
  margin-top: 6px;
}

select.wizard-input {
  appearance: none;
  cursor: pointer;
  padding-right: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 14px center;
}

.wizard-field__label {
  display: block;
  margin-bottom: 0.45rem;
  font-size: 0.78rem;
  color: #64748b;
  font-weight: 650;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.wizard-input:focus {
  outline: none;
  border-color: #fa7317;
  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.15);
}

.input-note {
  color: #6c757d;
  font-size: 14px;
  margin-top: 8px;
}

.form-section {
  margin-bottom: 30px;
}

/* Cabecera: saludo + créditos */
.wizard-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding-bottom: 0.85rem;
  margin-bottom: 0.35rem;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}

.credit-badge__loading {
  color: #94a3b8;
  font-weight: 400;
}

.credit-badge__greeting {
  font-size: 0.95rem;
  font-weight: 500;
  color: #64748b;
}

.credit-badge__greeting strong {
  color: #0f172a;
  font-weight: 700;
}

.credit-badge__credits {
  font-size: 0.75rem;
  font-weight: 650;
  color: #c2410c;
  background: rgba(255, 248, 244, 0.85);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(250, 115, 23, 0.28);
  padding: 0.35rem 0.75rem;
  border-radius: var(--app-radius, 12px);
  white-space: nowrap;
}

.form-section h3 {
  color: #495057;
  margin-bottom: 12px;
  font-size: 18px;
}

.radio-group {
  display: flex;
  gap: 20px;
  text-align: center;
  margin-bottom: 20px;
}

.radio-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  color: #495057;
}

.radio-option input {
  display: none;
}

.radio-custom {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #adb5bd;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
}

.radio-option input:checked + .radio-custom {
  border-color: #FA7317;
}

.radio-option input:checked + .radio-custom::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 10px;
  height: 10px;
  background: #FA7317;
  border-radius: 50%;
}

/* Tipo de propiedad: chips Casas / PH / Departamentos / Otros */
.property-type-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
}

.property-type-option {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  min-width: 0;
  padding: 0.75rem 0.9rem;
  border-radius: 12px;
  border: 1px solid rgba(250, 115, 23, 0.16);
  background: linear-gradient(155deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 247, 237, 0.7) 100%);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);
  color: #334155;
  font-size: 0.92rem;
  font-weight: 650;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
  -webkit-user-select: none;
          user-select: none;
}

.property-type-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.property-type-option:hover {
  border-color: rgba(250, 115, 23, 0.45);
}

.property-type-option--active {
  border-color: #fa7317;
  background: rgba(250, 115, 23, 0.1);
  color: #c2410c;
  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.12);
}

.property-type-other {
  margin-top: 0.85rem;
  padding: 0.85rem 0.9rem;
  border-radius: 12px;
  background: rgba(250, 115, 23, 0.05);
  border: 1px solid rgba(250, 115, 23, 0.16);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.property-type-other .wizard-field__label {
  margin-bottom: 0.35rem;
  text-transform: none;
  letter-spacing: 0;
  font-size: 0.82rem;
  color: #475569;
}

.property-type-other__hint {
  margin: 0.45rem 0 0;
  font-size: 0.8rem;
  line-height: 1.4;
  color: #64748b;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.amenities-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.85rem;
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
}

@media (max-width: 900px) {
  .amenities-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.wizard-step--amenities .wizard-step__subtitle {
  max-width: 36rem;
}

.amenity-option {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-height: 56px;
  padding: 0.85rem 1rem;
  border-radius: var(--app-radius, 12px);
  border: 1px solid rgba(250, 115, 23, 0.16);
  background: linear-gradient(155deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 247, 237, 0.7) 100%);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);
  color: #334155;
  font-size: 0.95rem;
  font-weight: 650;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  box-sizing: border-box;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    background 0.15s ease,
    color 0.15s ease;
}

.amenity-option:hover {
  border-color: rgba(250, 115, 23, 0.35);
  color: #0f172a;
}

.amenity-option.is-active {
  border-color: #fa7317;
  background: rgba(250, 115, 23, 0.1);
  color: #c2410c;
  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.12);
}

.amenity-option input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  pointer-events: none;
}

.amenity-option__check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border: 1.5px solid rgba(15, 23, 42, 0.18);
  border-radius: 4px;
  background: rgba(248, 250, 252, 0.95);
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
}

.amenity-option.is-active .amenity-option__check,
.amenity-option input[type="checkbox"]:checked + .amenity-option__check {
  background: #fa7317;
  border-color: #fa7317;
  box-shadow: 0 2px 6px rgba(250, 115, 23, 0.28);
}

.amenity-option.is-active .amenity-option__check::after,
.amenity-option input[type="checkbox"]:checked + .amenity-option__check::after {
  content: "";
  display: block;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) translateY(-1px);
}

.amenity-option__label {
  line-height: 1.2;
}

.amenity-option--cochera {
  justify-content: space-between;
  cursor: default;
}

.amenity-option__row {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  cursor: pointer;
  flex: 1 1;
  min-width: 0;
}

.amenity-option__stepper {
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;
  flex-shrink: 0;
  padding: 3px;
  border-radius: var(--app-radius, 12px);
  background: rgba(15, 23, 42, 0.05);
  border: 1px solid rgba(15, 23, 42, 0.06);
}

.amenity-option__stepper-btn {
  appearance: none;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: var(--app-radius, 12px);
  background: #fff;
  color: #c2410c;
  font-size: 0;
  line-height: 0;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  transition: background 0.15s ease, color 0.15s ease, opacity 0.15s ease;
}

.amenity-option__stepper-btn::before,
.amenity-option__stepper-btn:last-child::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  background: currentColor;
  border-radius: 1px;
  transform: translate(-50%, -50%);
}

.amenity-option__stepper-btn::before {
  width: 12px;
  height: 2px;
}

.amenity-option__stepper-btn:last-child::after {
  width: 2px;
  height: 12px;
}

.amenity-option__stepper-btn:hover:not(:disabled) {
  background: #fa7317;
  color: #fff;
}

.amenity-option__stepper-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  color: #94a3b8;
}

.amenity-option__stepper-value {
  min-width: 1.5rem;
  padding: 0 0.2rem;
  text-align: center;
  font-size: 0.95rem;
  font-weight: 750;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.p-button-secondary {
  border-radius: var(--app-radius, 12px);
}

/* Legacy checkbox styles (por si quedan usos) */
.checkbox-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  color: #495057;
  padding: 10px 12px;
  min-height: 48px;
  background: #f8f9fa;
  border: 1px solid transparent;
  border-radius: var(--app-radius, 12px);
  transition: background 0.2s, border-color 0.2s;
  box-sizing: border-box;
}

.checkbox-option:hover {
  background: #e9ecef;
}

.checkbox-option input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  pointer-events: none;
}

.checkbox-custom {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border: 2px solid #adb5bd;
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
  transition: all 0.2s;
  box-sizing: border-box;
}

.checkbox-option input[type="checkbox"]:checked + .checkbox-custom {
  background: #FA7317;
  border-color: #FA7317;
}

.checkbox-option input[type="checkbox"]:checked + .checkbox-custom::after {
  content: '';
  display: block;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) translateY(-1px);
}

.checkbox-option--cochera {
  justify-content: space-between;
  gap: 0.5rem;
  cursor: default;
}

.checkbox-option--cochera.is-active {
  border-color: rgba(250, 115, 23, 0.35);
}

.checkbox-option__row {
  display: flex;
  align-items: center;
  cursor: pointer;
  flex: 1 1;
  min-width: 0;
}

.checkbox-option__quantity {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
}

.checkbox-option__quantity-label {
  font-size: 0.8rem;
  font-weight: 500;
  color: #6b7280;
  white-space: nowrap;
}

.checkbox-option__quantity-input {
  width: 56px;
  padding: 6px 8px;
  border: 1px solid rgba(250, 115, 23, 0.5);
  border-radius: var(--app-radius, 12px);
  font-size: 15px;
  text-align: center;
  color: #343a40;
  background: #fff;
  box-sizing: border-box;
  -moz-appearance: textfield;
}

.checkbox-option__quantity-input::-webkit-outer-spin-button,
.checkbox-option__quantity-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.checkbox-option__quantity-input:focus {
  outline: none;
  border-color: #FA7317;
  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.12);
}

.characteristic-field {
  --cf-radius: 12px;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  padding: 0.95rem 1rem 1rem;
  border-radius: var(--cf-radius);
  border: 1px solid rgba(250, 115, 23, 0.16);
  background: linear-gradient(155deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 247, 237, 0.7) 100%);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);
  transition:
    border-color 0.18s ease,
    box-shadow 0.18s ease,
    background 0.18s ease;
}

.characteristic-field:hover {
  border-color: rgba(250, 115, 23, 0.22);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.95) inset,
    0 10px 24px rgba(15, 23, 42, 0.06);
}

.characteristic-field:focus-within {
  border-color: rgba(250, 115, 23, 0.5);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.95) inset,
    0 0 0 3px rgba(250, 115, 23, 0.12),
    0 12px 28px rgba(250, 115, 23, 0.08);
}

.characteristic-field__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  min-height: 28px;
}

.characteristic-field__label {
  display: block;
  margin: 0;
  color: #475569;
  font-size: 0.72rem;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.2;
}

.characteristic-field__mode {
  display: inline-flex;
  align-items: center;
  padding: 2px;
  border-radius: var(--app-radius, 12px);
  background: rgba(15, 23, 42, 0.06);
  border: 1px solid rgba(15, 23, 42, 0.05);
  flex-shrink: 0;
}

.characteristic-field__mode-btn {
  appearance: none;
  border: none;
  background: transparent;
  margin: 0;
  padding: 0.28rem 0.55rem;
  border-radius: var(--app-radius, 12px);
  color: #64748b;
  font: inherit;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.characteristic-field__mode-btn:hover {
  color: #0f172a;
}

.characteristic-field__mode-btn.is-active {
  background: #fff;
  color: #c2410c;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.1);
}

.characteristic-field--range .characteristic-field__mode-btn.is-active {
  background: #fa7317;
  color: #fff;
  box-shadow: 0 2px 8px rgba(250, 115, 23, 0.28);
}

.characteristic-field__control {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1 1;
}

.characteristic-field__input {
  width: 100%;
  min-height: 52px;
  margin: 0;
  padding: 14px 16px;
  border: 1px solid rgba(250, 115, 23, 0.16);
  border-radius: 12px;
  background: #fff;
  color: #0f172a;
  font: inherit;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  text-align: center;
  font-variant-numeric: tabular-nums;
  box-sizing: border-box;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
  -moz-appearance: textfield;
}

.characteristic-field__input::-webkit-outer-spin-button,
.characteristic-field__input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.characteristic-field__input::placeholder {
  color: #94a3b8;
  font-weight: 550;
  letter-spacing: 0;
  font-size: 0.95rem;
}

.characteristic-field__input:hover {
  border-color: rgba(250, 115, 23, 0.28);
  background: #fff;
}

.characteristic-field__input:focus {
  outline: none;
  border-color: #fa7317;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.15);
}

.characteristic-field__chip {
  display: none;
}

.characteristic-field__range .characteristic-field__input {
  padding: 0.7rem 0.75rem;
  font-size: 1.1rem;
  text-align: center;
  min-height: 52px;
}

.characteristic-field__range {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.characteristic-field__separator {
  color: #cbd5e1;
  font-weight: 600;
  font-size: 1rem;
  flex-shrink: 0;
  line-height: 1;
}

.characteristics-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem 1.1rem;
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
}

.characteristics-grid .characteristic-field:nth-child(-n + 3) {
  grid-column: span 2;
}

.characteristics-grid .characteristic-field:nth-child(4),
.characteristics-grid .characteristic-field:nth-child(5) {
  grid-column: span 3;
}

.characteristics-grid.characteristics-grid--single .characteristic-field:nth-child(n) {
  grid-column: 3 / span 2;
}

.wizard-step--characteristics .wizard-step__subtitle {
  max-width: 42rem;
}

.wizard-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 28px;
  padding-top: 18px;
  border-top: 1px solid #e9ecef;
}

.wizard-footer__back,
.wizard-footer__forward {
  display: flex;
  align-items: center;
}

.wizard-footer__back:empty {
  display: none;
}

.wizard-footer__back {
  justify-content: flex-start;
}

.wizard-footer__forward {
  margin-left: auto;
  justify-content: flex-end;
}

.wizard-footer__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  margin: 0;
  min-height: 44px;
  padding: 0.7rem 1.2rem;
  border-radius: var(--app-radius, 12px);
  font-weight: 600;
  font-size: 0.95rem;
  line-height: 1.2;
  box-sizing: border-box;
}

.wizard-footer .details-button.wizard-footer__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  width: auto;
  max-width: none;
  margin: 0;
  padding: 0.7rem 1.2rem;
  border-radius: var(--app-radius, 12px);
}

.wizard-footer .details-button {
  margin-top: 0;
  margin-right: 0;
}

.wizard-footer .wizard-footer__btn,
.wizard-footer .details-button.wizard-footer__btn,
.wizard-footer .p-button-secondary.wizard-footer__btn {
  border: none;
  background: linear-gradient(135deg, #fa7317 0%, #c2410c 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(250, 115, 23, 0.25);
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.wizard-footer .wizard-footer__btn:hover,
.wizard-footer .details-button.wizard-footer__btn:hover,
.wizard-footer .p-button-secondary.wizard-footer__btn:hover {
  transform: translateY(-1px);
  background: linear-gradient(135deg, #fa7317 0%, #c2410c 100%);
  color: #fff;
  box-shadow: 0 6px 18px rgba(250, 115, 23, 0.35);
}

.wizard-footer .wizard-footer__btn:disabled {
  opacity: 0.55;
  transform: none;
  cursor: not-allowed;
  box-shadow: none;
}

.wizard-footer__btn span {
  line-height: 1.2;
}

.wizard-footer__btn .pi {
  font-size: 0.8rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.wizard-footer__btn--next .pi {
  margin-left: 0.1rem;
}

/* ---------- Tablet ---------- */
@media (max-width: 1024px) {
  .property-wizard-container {
    max-width: 960px;
  }
  .checkbox-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ---------- Mobile ---------- */
@media (max-width: 768px) {
  .property-form-page {
    padding: 16px 12px;
    align-items: center;
  }

  .property-form-page__logo {
    height: 48px;
  }

  .property-form-page .property-wizard-container {
    min-height: auto;
    margin: 0 auto;
    border-radius: var(--app-radius, 12px);
    box-shadow:
      0 1px 0 rgba(255, 255, 255, 0.8) inset,
      0 10px 36px rgba(15, 23, 42, 0.08);
    padding: 16px;
    padding-bottom: 20px;
    background: rgba(255, 255, 255, 0.82);
    backdrop-filter: blur(18px) saturate(1.2);
    -webkit-backdrop-filter: blur(18px) saturate(1.2);
  }

  .wizard-modal {
    padding: 0;
    align-items: stretch;
  }

  .property-wizard-container {
    max-width: 100%;
    margin: 0;
    min-height: 100dvh;       /* garantiza altura completa en mobile */
    border-radius: 0;
    padding: 16px;
    padding-bottom: 96px;     /* deja lugar para el footer sticky */
    box-shadow: none;
  }

  .wizard-header {
    margin-bottom: 20px;
  }

  .wizard-step h2,
  .wizard-step__title {
    font-size: 1.3rem;
  }

  .subtitle,
  .wizard-step__subtitle {
    font-size: 0.92rem;
    margin-bottom: 1.15rem;
  }

  .wizard-step--location .wizard-step__body {
    gap: 1.05rem;
  }

  .operation-options {
    grid-template-columns: 1fr;
  }

  .operation-option,
  .property-type-option {
    min-height: 46px;
    font-size: 0.9rem;
  }

  .checkbox-grid,
  .amenities-grid {
    grid-template-columns: 1fr 1fr;
    gap: 0.7rem;
  }

  .amenity-option {
    min-height: 52px;
    padding: 0.75rem 0.85rem;
    font-size: 0.9rem;
  }

  .amenity-option--cochera {
    grid-column: 1 / -1;
  }

  .characteristic-field {
    padding: 0.8rem 0.85rem 0.9rem;
    gap: 0.55rem;
  }

  .characteristic-field__input {
    min-height: 48px;
    font-size: 1.1rem;
  }

  .characteristic-field__mode-btn {
    padding: 0.3rem 0.48rem;
    font-size: 0.66rem;
  }

  .characteristic-field__range .characteristic-field__input {
    padding: 0.65rem 0.55rem;
    font-size: 1rem;
    min-height: 48px;
  }

  .characteristics-grid {
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;
    max-width: none;
  }

  .characteristics-grid .characteristic-field:nth-child(-n + 5) {
    grid-column: auto;
  }

  .characteristics-grid--single {
    grid-template-columns: 1fr;
    max-width: 420px;
  }

  .characteristics-grid.characteristics-grid--single .characteristic-field:nth-child(n) {
    grid-column: auto;
  }

  .radio-group {
    flex-direction: column;
    gap: 10px;
  }

  .wizard-input,
  select.wizard-input,
  input.wizard-input {
    font-size: 16px;           /* 16px evita el zoom en iOS */
    padding: 10px 12px;
  }

  select.wizard-input {
    padding-right: 36px;
  }

  /* Footer sticky para que los botones queden siempre a la vista */
  .wizard-footer {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    flex-direction: row;
    gap: 10px;
    margin-top: 20px;
    padding: 12px 16px;
    background: #fff;
    border-top: 1px solid #e9ecef;
    box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.05);
    /* anular el margin horizontal del container para que llene el ancho */
    margin-left: -16px;
    margin-right: -16px;
  }

  .property-form-page .wizard-footer {
    position: static;
    margin: 20px 0 0;
    padding: 16px 0 0;
    background: transparent;
    box-shadow: none;
  }

  .wizard-footer__btn {
    padding: 12px;
    font-size: 15px;
  }

  .wizard-footer__back:not(:empty) .wizard-footer__btn,
  .wizard-footer__back:not(:empty) + .wizard-footer__forward .wizard-footer__btn {
    flex: 1 1;
  }

  .wizard-top-bar {
    gap: 0.5rem;
  }

  .credit-badge__credits {
    font-size: 0.72rem;
    white-space: normal;
    text-align: right;
  }
}

/* ---------- Mobile chico ---------- */
@media (max-width: 480px) {
  .checkbox-grid,
  .amenities-grid {
    grid-template-columns: 1fr;
  }

  .characteristics-grid {
    grid-template-columns: 1fr;
  }
}
.wizard-guide {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(230px, 0.9fr);
  gap: 14px;
  margin: 0 0 22px;
  padding: 14px;
  background: #f8fafc;
  border: 1px solid #c7d2fe;
  border-left: 4px solid #4f46e5;
  border-radius: var(--app-radius, 12px);
  text-align: left;
}

.wizard-guide__main {
  display: flex;
  gap: 12px;
  min-width: 0;
}

.wizard-guide__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  border-radius: var(--app-radius, 12px);
  color: #c2410c;
  background: #fff7ed;
  border: 1px solid #fed7aa;
}

.wizard-guide__eyebrow {
  margin: 0 0 2px;
  color: #4338ca;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.wizard-guide h2 {
  margin: 0 0 4px;
  color: #1f2937;
  font-size: 1rem;
  line-height: 1.25;
  text-align: left;
}

.wizard-guide__main p:not(.wizard-guide__eyebrow) {
  margin: 0;
  color: #374151;
  font-size: 0.9rem;
  line-height: 1.45;
}

.wizard-guide__steps {
  margin: 0;
  padding-left: 1.2rem;
  color: #4b5563;
  font-size: 0.86rem;
  line-height: 1.45;
}

.wizard-guide__steps li + li {
  margin-top: 0.25rem;
}

.wizard-guide__tip {
  grid-column: 1 / -1;
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e2e8f0;
  color: #0f766e;
  font-size: 0.84rem;
  line-height: 1.4;
}

@media (max-width: 768px) {
  .wizard-guide {
    grid-template-columns: 1fr;
    gap: 10px;
    margin-bottom: 18px;
    padding: 12px;
  }

  .wizard-guide h2 {
    font-size: 0.96rem;
  }

  .wizard-guide__steps {
    font-size: 0.84rem;
  }
}
/* property-form-scroll-fix: /property-form vive fuera del modal y necesita su propio scroll. */
.property-form-page .property-wizard-container {
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  padding-bottom: 20px;
}

@supports (height: 100dvh) {
  .property-form-page .property-wizard-container {
    max-height: calc(100dvh - 120px);
  }
}

.property-form-page .wizard-header {
  margin-bottom: 14px;
}

.property-form-page .wizard-guide {
  gap: 10px;
  margin-bottom: 14px;
  padding: 12px;
}

.property-form-page .wizard-guide__main p:not(.wizard-guide__eyebrow) {
  font-size: 0.84rem;
  line-height: 1.35;
}

.property-form-page .wizard-guide__steps {
  font-size: 0.8rem;
  line-height: 1.35;
}

.property-form-page .wizard-guide__tip {
  padding-top: 0.55rem;
  font-size: 0.78rem;
  line-height: 1.35;
}

.property-form-page .wizard-footer {
  position: static;
  margin: 24px 0 0;
  padding: 18px 0 0;
  background: transparent;
  box-shadow: none;
  border-top: 1px solid #e9ecef;
}

/* Paso 2: la página vuelve a scrollear cuando el mapa no entra en la pantalla. */
.property-form-page:has(.property-wizard-container--fit) {
  height: auto;
  max-height: none;
  overflow: visible;
  justify-content: safe center;
}

.property-form-page .property-wizard-container--fit {
  flex: 0 1 auto;
  min-height: 0;
  max-height: none;
  overflow: visible;
  display: flex;
  flex-direction: column;
  scrollbar-gutter: auto;
  padding-bottom: 14px;
}

.property-wizard-container--fit .wizard-top-bar,
.property-wizard-container--fit .wizard-header,
.property-wizard-container--fit .wizard-footer {
  flex-shrink: 0;
}

.property-wizard-container--fit .wizard-header {
  margin-bottom: 8px;
}

.property-wizard-container--fit .wizard-footer {
  margin-top: 12px;
  padding-top: 12px;
}

.property-wizard-container--fit .wizard-content {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.property-wizard-container--fit .wizard-step--zone {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.property-wizard-container--fit .wizard-step--zone .wizard-step__intro {
  flex-shrink: 0;
}

.property-wizard-container--fit .wizard-step--zone > .map-preview-modal--embedded {
  flex: none;
  min-height: 0;
  height: auto;
}

.property-wizard-container--fit .wizard-step--zone .map-preview-card {
  flex: none;
  height: auto;
  min-height: 0;
  overflow: visible;
}

@media (min-width: 769px) and (max-height: 900px) {
  .property-form-page {
    gap: 0.75rem;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .property-form-page__logo {
    height: 48px;
  }

  .property-form-page .property-wizard-container {
    max-width: 1480px;
    max-height: calc(100vh - 100px);
    padding: 14px 16px 16px;
  }

  @supports (height: 100dvh) {
    .property-form-page .property-wizard-container {
      max-height: calc(100dvh - 68px);
    }
  }

  .property-form-page .wizard-top-bar {
    padding-bottom: 0.35rem;
  }

  .property-form-page .credit-badge__greeting {
    font-size: 1.05rem;
  }

  .property-form-page .credit-badge__credits {
    font-size: 0.76rem;
  }

  .property-form-page .wizard-header {
    margin-bottom: 10px;
  }

  .property-form-page .progress-bar {
    height: 6px;
    margin-bottom: 6px;
  }

  .property-form-page .step-indicator {
    font-size: 12px;
  }

  .property-form-page .wizard-guide {
    gap: 8px;
    margin-bottom: 10px;
    padding: 10px;
  }

  .property-form-page .wizard-guide__icon {
    flex-basis: 34px;
    width: 34px;
    height: 34px;
  }

  .property-form-page .wizard-guide h2 {
    font-size: 0.92rem;
  }

  .property-form-page .wizard-guide__main p:not(.wizard-guide__eyebrow) {
    font-size: 0.78rem;
    line-height: 1.28;
  }

  .property-form-page .wizard-guide__steps {
    font-size: 0.74rem;
    line-height: 1.3;
  }

  .property-form-page .wizard-guide__tip {
    font-size: 0.72rem;
    line-height: 1.28;
  }

  .property-form-page .wizard-step h2 {
    font-size: 20px;
    margin-bottom: 4px;
  }

  .property-form-page .subtitle {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .property-form-page .input-group,
  .property-form-page .form-section {
    margin-bottom: 12px;
  }

  .property-form-page .characteristics-grid,
  .property-form-page .amenities-grid {
    gap: 12px;
  }

  .property-form-page .wizard-footer {
    margin: 16px 0 0;
    padding: 14px 0 0;
  }
}

@media (min-width: 769px) and (max-height: 760px) {
  .property-form-page .property-wizard-container {
    max-width: 1480px;
    padding: 12px 14px 14px;
  }

  .property-form-page .wizard-guide {
    grid-template-columns: 1fr;
    gap: 7px;
    padding: 9px;
  }

  .property-form-page .wizard-guide__steps {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
    padding-left: 0;
    list-style-position: inside;
  }

  .property-form-page .wizard-guide__steps li + li {
    margin-top: 0;
  }

  .property-form-page .wizard-guide__tip {
    display: none;
  }
}

@media (min-width: 769px) and (max-height: 660px) {
  .property-form-page .wizard-guide__steps {
    display: none;
  }

  .property-form-page .wizard-footer__btn {
    padding: 9px 12px;
    font-size: 13px;
  }
}

/* Paso del mapa en monitores bajos: compactar el marco para que el mapa
   y los controles quepan, sin recortar el contenido. */
@media (min-width: 769px) and (max-height: 720px) {
  .property-form-page:has(.property-wizard-container--fit) {
    gap: 0.4rem;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .property-form-page:has(.property-wizard-container--fit) .property-form-page__logo {
    height: 36px;
  }

  .property-form-page .property-wizard-container--fit {
    padding: 10px 14px 10px;
  }

  .property-wizard-container--fit .wizard-header {
    margin-bottom: 4px;
  }

  .property-wizard-container--fit .wizard-step--zone .wizard-step__title {
    margin-bottom: 0.15rem;
    font-size: 1.25rem;
  }

  .property-wizard-container--fit .wizard-step--zone .wizard-step__subtitle {
    font-size: 0.84rem;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .property-wizard-container--fit .wizard-footer {
    margin-top: 8px;
    padding-top: 8px;
  }

  .property-form-page:has(.property-wizard-container--fit) > .wizard-help-trigger {
    padding-top: 0;
    padding-bottom: 0;
    font-size: 0.84rem;
  }
}

.property-form-page .property-wizard-container.property-wizard-container--fit {
  max-height: none;
  overflow: visible;
}
/* wizard-modal-scroll-fix: el instructivo no debe tapar los botones del modal. */
.wizard-modal {
  overflow: hidden;
  padding: 16px;
}

.wizard-modal .property-wizard-container {
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

@supports (height: 100dvh) {
  .wizard-modal .property-wizard-container {
    max-height: calc(100dvh - 32px);
  }
}

.wizard-modal .wizard-header {
  margin-bottom: 14px;
}

.wizard-modal .wizard-guide {
  gap: 10px;
  margin-bottom: 14px;
  padding: 12px;
}

.wizard-modal .wizard-guide__main p:not(.wizard-guide__eyebrow) {
  font-size: 0.84rem;
  line-height: 1.35;
}

.wizard-modal .wizard-guide__steps {
  font-size: 0.8rem;
  line-height: 1.35;
}

.wizard-modal .wizard-guide__tip {
  padding-top: 0.55rem;
  font-size: 0.78rem;
  line-height: 1.35;
}

.wizard-modal .wizard-footer {
  position: sticky;
  bottom: 0;
  z-index: 8;
  margin: 18px -20px -20px;
  padding: 12px 20px;
  background: #fff;
  box-shadow: 0 -4px 12px rgba(15, 23, 42, 0.08);
}

@media (min-width: 769px) and (max-height: 860px) {
  .wizard-modal {
    padding: 10px;
  }

  .wizard-modal .property-wizard-container {
    max-width: 1040px;
    max-height: calc(100vh - 20px);
    padding: 14px 16px 0;
  }

  @supports (height: 100dvh) {
    .wizard-modal .property-wizard-container {
      max-height: calc(100dvh - 20px);
    }
  }

  .wizard-modal .wizard-top-bar {
    padding-bottom: 0.35rem;
  }

  .wizard-modal .credit-badge__greeting {
    font-size: 1.05rem;
  }

  .wizard-modal .credit-badge__credits {
    font-size: 0.76rem;
  }

  .wizard-modal .wizard-header {
    margin-bottom: 10px;
  }

  .wizard-modal .progress-bar {
    height: 6px;
    margin-bottom: 6px;
  }

  .wizard-modal .step-indicator {
    font-size: 12px;
  }

  .wizard-modal .wizard-guide {
    gap: 8px;
    margin-bottom: 10px;
    padding: 10px;
  }

  .wizard-modal .wizard-guide__main {
    gap: 9px;
  }

  .wizard-modal .wizard-guide__icon {
    flex-basis: 34px;
    width: 34px;
    height: 34px;
  }

  .wizard-modal .wizard-guide h2 {
    font-size: 0.92rem;
  }

  .wizard-modal .wizard-guide__main p:not(.wizard-guide__eyebrow) {
    font-size: 0.78rem;
    line-height: 1.28;
  }

  .wizard-modal .wizard-guide__steps {
    font-size: 0.74rem;
    line-height: 1.3;
  }

  .wizard-modal .wizard-guide__tip {
    font-size: 0.72rem;
    line-height: 1.28;
  }

  .wizard-modal .wizard-step h2 {
    font-size: 20px;
    margin-bottom: 4px;
  }

  .wizard-modal .subtitle {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .wizard-modal .input-group,
  .wizard-modal .form-section {
    margin-bottom: 12px;
  }

  .wizard-modal .characteristics-grid,
  .wizard-modal .amenities-grid {
    gap: 12px;
  }

  .wizard-modal .wizard-footer {
    margin: 12px -16px 0;
    padding: 10px 16px;
  }
}

@media (min-width: 769px) and (max-height: 760px) {
  .wizard-modal .property-wizard-container {
    max-width: 1000px;
    padding: 12px 14px 0;
  }

  .wizard-modal .wizard-guide {
    grid-template-columns: 1fr;
    gap: 7px;
    padding: 9px;
  }

  .wizard-modal .wizard-guide__steps {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
    padding-left: 0;
    list-style-position: inside;
  }

  .wizard-modal .wizard-guide__steps li + li {
    margin-top: 0;
  }

  .wizard-modal .wizard-guide__tip {
    display: none;
  }

  .wizard-modal .wizard-step h2 {
    font-size: 18px;
  }

  .wizard-modal .subtitle {
    font-size: 13px;
    margin-bottom: 10px;
  }
}

@media (min-width: 769px) and (max-height: 660px) {
  .wizard-modal .wizard-guide__steps {
    display: none;
  }

  .wizard-modal .wizard-guide__main p:not(.wizard-guide__eyebrow) {
    font-size: 0.76rem;
  }

  .wizard-modal .wizard-header {
    margin-bottom: 8px;
  }

  .wizard-modal .wizard-footer__btn {
    padding: 9px 12px;
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .wizard-modal {
    padding: 0;
  }

  .wizard-modal .property-wizard-container {
    height: 100vh;
    max-height: 100vh;
    padding-bottom: 0;
  }

  @supports (height: 100dvh) {
    .wizard-modal .property-wizard-container {
      height: 100dvh;
      max-height: 100dvh;
    }
  }

  .wizard-modal .wizard-guide {
    gap: 8px;
    margin-bottom: 12px;
    padding: 10px;
  }

  .wizard-modal .wizard-guide__tip {
    display: none;
  }

  .wizard-modal .wizard-footer {
    margin: 18px -16px 0;
    padding: 12px 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PropertyWizard.css"],"names":[],"mappings":"AAAA;uEACuE;AACvE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,oDAAoD;AACpD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B;;kEAEgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;sDACsD;AACtD;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,yCAAyC;EACzC,iDAAiD;EACjD,0CAA0C;EAC1C,gCAAgC;EAChC;;sCAEoC;EACpC,gHAAgH;AAClH;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,sCAAsC;EACtC,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,wBAAwB;EACxB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wFAAwF;AACxF;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;EAC1B,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,0CAA0C;EAC1C,gGAAgG;EAChG,8CAA8C;EAC9C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,iFAAiF;AACnF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,0DAA0D;EAC1D,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yDAA+Q;EAC/Q,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,0CAA0C;EAC1C,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,gGAAgG;EAChG,8CAA8C;EAC9C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iFAAiF;EACjF,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,sCAAsC;EACtC,0CAA0C;EAC1C,gGAAgG;EAChG,8CAA8C;EAC9C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;EACtB;;;;oBAIkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,iFAAiF;EACjF,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,SAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,sCAAsC;EACtC,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,eAAe;EACf,4CAA4C;EAC5C,uEAAuE;AACzE;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,sCAAsC;EACtC,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,+BAA+B;EAC/B,0CAA0C;EAC1C,gGAAgG;EAChG,8CAA8C;EAC9C;;;yBAGuB;AACzB;;AAEA;EACE,sCAAsC;EACtC;;sCAEoC;AACtC;;AAEA;EACE,qCAAqC;EACrC;;;wCAGsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,sCAAsC;EACtC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,0EAA0E;AAC5E;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;EACtB,iFAAiF;EACjF,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;;EAGE,YAAY;EACZ,6DAA6D;EAC7D,WAAW;EACX,+CAA+C;EAC/C,eAAe;EACf,uDAAuD;AACzD;;AAEA;;;EAGE,2BAA2B;EAC3B,6DAA6D;EAC7D,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE;IACE,gBAAgB;EAClB;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,sCAAsC;IACtC;;wCAEoC;IACpC,aAAa;IACb,oBAAoB;IACpB,qCAAqC;IACrC,yCAAyC;IACzC,iDAAiD;EACnD;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,kBAAkB,QAAQ,wCAAwC;IAClE,gBAAgB;IAChB,aAAa;IACb,oBAAoB,MAAM,qCAAqC;IAC/D,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;;IAGE,eAAe,YAAY,8BAA8B;IACzD,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,iEAAiE;EACjE;IACE,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,2CAA2C;IAC3C,sEAAsE;IACtE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;;IAEE,SAAO;EACT;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA,uCAAuC;AACvC;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;AACA,+FAA+F;AAC/F;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,iFAAiF;AACjF;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,uBAAuB;EACzB;;EAEA;IACE;MACE,+BAA+B;IACjC;EACF;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;uDACuD;AACvD;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA,iFAAiF;AACjF;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE;MACE,+BAA+B;IACjC;EACF;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE;MACE,cAAc;MACd,kBAAkB;IACpB;EACF;;EAEA;IACE,QAAQ;IACR,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF","sourcesContent":["/* Wrapper/overlay que muestra el wizard sobre el Home.\n   Es scrolleable (por eso overrideamos el overflow:hidden del body). */\n.wizard-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 1500;\n  background: rgba(0, 0, 0, 0.35);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 20px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n/* Ruta /property-form — card centrada en pantalla */\n.property-form-page {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1.25rem;\n  padding: 24px max(28px, 4vw);\n  background:\n    radial-gradient(ellipse 80% 50% at 50% -10%, rgba(250, 115, 23, 0.14), transparent 55%),\n    linear-gradient(165deg, #fff7ed 0%, #f3f4f6 48%, #eef2f7 100%);\n  box-sizing: border-box;\n}\n\n.property-form-page__logo {\n  height: 58px;\n  width: auto;\n  flex-shrink: 0;\n}\n\n/* Estilos para el asistente de propiedades\n   Radio unificado con CTA landing/dashboard (12px). */\n.property-wizard-container {\n  --app-radius: 12px;\n  width: 100%;\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 22px 24px;\n  background: rgba(255, 255, 255, 0.78);\n  backdrop-filter: blur(18px) saturate(1.2);\n  -webkit-backdrop-filter: blur(18px) saturate(1.2);\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  border-radius: var(--app-radius);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.8) inset,\n    0 10px 36px rgba(15, 23, 42, 0.08);\n  font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n}\n\n.property-wizard-container .wizard-step h2,\n.property-wizard-container .wizard-step h3,\n.property-wizard-container .wizard-step .subtitle,\n.property-wizard-container .wizard-step__title,\n.property-wizard-container .wizard-step__subtitle {\n  text-align: center;\n}\n\n.wizard-header {\n  margin-bottom: 22px;\n}\n\n.progress-bar {\n  height: 6px;\n  background: rgba(254, 215, 170, 0.55);\n  border-radius: var(--app-radius, 12px);\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n\n.progress {\n  height: 100%;\n  background: linear-gradient(90deg, #fa7317, #fb923c);\n  border-radius: var(--app-radius, 12px);\n  transition: width 0.35s ease;\n  min-width: 0;\n}\n\n.step-indicator {\n  text-align: center;\n  color: #c2410c;\n  font-weight: 700;\n  font-size: 0.78rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.wizard-help-trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  margin: 0;\n  padding: 0.35rem 0.5rem;\n  border: none;\n  background: transparent;\n  color: #c2410c;\n  font: inherit;\n  font-size: 0.92rem;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  text-decoration-color: rgba(194, 65, 12, 0.35);\n}\n\n.wizard-help-trigger:hover {\n  color: #9a3412;\n  text-decoration-color: rgba(154, 52, 18, 0.55);\n}\n\n.wizard-help-trigger .pi {\n  font-size: 0.95rem;\n}\n\n.property-form-page > .wizard-help-trigger {\n  flex-shrink: 0;\n}\n\n.wizard-modal > .wizard-help-trigger {\n  margin-top: 0.75rem;\n}\n\n/* Drawer — ayuda del paso (Paso 1) */\n.wizard-help-drawer.p-sidebar {\n  width: min(400px, 100vw);\n  background: #fff;\n  box-shadow: -12px 0 36px rgba(15, 23, 42, 0.12);\n}\n\n.wizard-help-drawer .p-sidebar-header {\n  padding: 0.85rem 1rem 0;\n  justify-content: flex-end;\n}\n\n.wizard-help-drawer .p-sidebar-content {\n  padding: 0 1.25rem 1.5rem;\n}\n\n.wizard-help-drawer__body {\n  text-align: left;\n}\n\n.wizard-help-drawer__header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.wizard-help-drawer__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 44px;\n  width: 44px;\n  height: 44px;\n  border-radius: var(--app-radius, 12px);\n  color: #c2410c;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n}\n\n.wizard-help-drawer__eyebrow {\n  margin: 0 0 0.1rem;\n  color: #c2410c;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.wizard-help-drawer__title {\n  margin: 0;\n  color: #1f2937;\n  font-size: 1.15rem;\n  line-height: 1.25;\n}\n\n.wizard-help-drawer__lead {\n  margin: 0 0 1rem;\n  color: #374151;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.wizard-help-drawer__steps {\n  margin: 0;\n  padding-left: 1.2rem;\n  color: #4b5563;\n  font-size: 0.92rem;\n  line-height: 1.45;\n}\n\n.wizard-help-drawer__steps li + li {\n  margin-top: 0.45rem;\n}\n\n.wizard-help-drawer__tip {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  margin-top: 1.15rem;\n  padding-top: 1rem;\n  border-top: 1px solid #fee2c5;\n  color: #0f766e;\n  font-size: 0.88rem;\n  line-height: 1.4;\n}\n\n.wizard-help-drawer__tip .pi {\n  margin-top: 0.1rem;\n  flex-shrink: 0;\n}\n\n@media (max-width: 520px) {\n  .wizard-help-drawer.p-sidebar {\n    width: 100vw;\n  }\n}\n\n.wizard-step h2 {\n  color: #0f172a;\n  font-size: clamp(1.35rem, 2.4vw, 1.75rem);\n  font-weight: 750;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  margin: 0 0 0.4rem;\n}\n\n.subtitle {\n  color: #64748b;\n  margin: 0 0 1.5rem;\n  font-size: 0.98rem;\n  line-height: 1.45;\n}\n\n/* Paso 1 — jerarquía y layout */\n.wizard-step__intro {\n  margin-bottom: 1.5rem;\n}\n\n.wizard-step__title {\n  margin: 0 0 0.4rem;\n  color: #0f172a;\n  font-size: clamp(1.4rem, 2.6vw, 1.85rem);\n  font-weight: 750;\n  letter-spacing: -0.025em;\n  line-height: 1.18;\n}\n\n.wizard-step__subtitle {\n  margin: 0 auto;\n  max-width: 34rem;\n  color: #64748b;\n  font-size: 0.98rem;\n  line-height: 1.45;\n  font-weight: 400;\n}\n\n.wizard-step__subtitle strong {\n  color: #0f172a;\n  font-weight: 650;\n}\n\n.wizard-step--zone .wizard-step__subtitle {\n  max-width: 42rem;\n}\n\n.wizard-step--location .wizard-step__body {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  width: 100%;\n  max-width: 560px;\n  margin: 0 auto;\n}\n\n/* Paso 1 en /property-form: el card es más ancho y el contenido usa las dos columnas. */\n.property-form-page .property-wizard-container {\n  max-width: 1480px;\n}\n\n.property-form-page .wizard-step--location .wizard-step__body {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  width: 100%;\n  max-width: 640px;\n  margin: 0 auto;\n}\n\n.wizard-step--location .wizard-field {\n  width: 100%;\n  text-align: left;\n}\n\n.custom-searchbox-wrapper {\n  width: 100%;\n  position: relative !important;\n  left: auto !important;\n  top: auto !important;\n  transform: none !important;\n  display: flex;\n  justify-content: stretch;\n}\n\n.custom-searchbox-wrapper * {\n  position: relative !important;\n  left: auto !important;\n  top: auto !important;\n  transform: none !important;\n}\n\n.custom-searchbox-wrapper #pac-input {\n  width: 100%;\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  background: #fff;\n  color: #0f172a;\n  font: inherit;\n  font-size: 16px;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.custom-searchbox-wrapper #pac-input:focus {\n  outline: none;\n  border-color: #fa7317;\n  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.15);\n}\n\n.operation-options {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.65rem;\n}\n\n.operation-option {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  padding: 0.75rem 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  background: linear-gradient(155deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 247, 237, 0.7) 100%);\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);\n  color: #334155;\n  font-size: 0.95rem;\n  font-weight: 650;\n  cursor: pointer;\n  user-select: none;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.operation-option input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.operation-option:hover {\n  border-color: rgba(250, 115, 23, 0.45);\n}\n\n.operation-option--active {\n  border-color: #fa7317;\n  background: rgba(250, 115, 23, 0.1);\n  color: #c2410c;\n  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.12);\n}\n\n.input-group {\n  margin-bottom: 20px;\n}\n\n.input-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: #495057;\n  font-weight: 500;\n}\n\n.wizard-input {\n  width: 100%;\n  padding: 14px 16px;\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  border-radius: 12px;\n  font: inherit;\n  font-size: 16px;\n  color: #0f172a;\n  background: #fff;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-sizing: border-box;\n}\n\n.wizard-select {\n  margin-top: 6px;\n}\n\nselect.wizard-input {\n  appearance: none;\n  cursor: pointer;\n  padding-right: 40px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='none' stroke='%2364748b' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round' d='M1 1.5 6 6.5 11 1.5'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n}\n\n.wizard-field__label {\n  display: block;\n  margin-bottom: 0.45rem;\n  font-size: 0.78rem;\n  color: #64748b;\n  font-weight: 650;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.wizard-input:focus {\n  outline: none;\n  border-color: #fa7317;\n  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.15);\n}\n\n.input-note {\n  color: #6c757d;\n  font-size: 14px;\n  margin-top: 8px;\n}\n\n.form-section {\n  margin-bottom: 30px;\n}\n\n/* Cabecera: saludo + créditos */\n.wizard-top-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n  padding-bottom: 0.85rem;\n  margin-bottom: 0.35rem;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.06);\n}\n\n.credit-badge__loading {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.credit-badge__greeting {\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.credit-badge__greeting strong {\n  color: #0f172a;\n  font-weight: 700;\n}\n\n.credit-badge__credits {\n  font-size: 0.75rem;\n  font-weight: 650;\n  color: #c2410c;\n  background: rgba(255, 248, 244, 0.85);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border: 1px solid rgba(250, 115, 23, 0.28);\n  padding: 0.35rem 0.75rem;\n  border-radius: var(--app-radius, 12px);\n  white-space: nowrap;\n}\n\n.form-section h3 {\n  color: #495057;\n  margin-bottom: 12px;\n  font-size: 18px;\n}\n\n.radio-group {\n  display: flex;\n  gap: 20px;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.radio-option {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: 16px;\n  color: #495057;\n}\n\n.radio-option input {\n  display: none;\n}\n\n.radio-custom {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #adb5bd;\n  border-radius: 50%;\n  margin-right: 10px;\n  position: relative;\n}\n\n.radio-option input:checked + .radio-custom {\n  border-color: #FA7317;\n}\n\n.radio-option input:checked + .radio-custom::after {\n  content: '';\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 10px;\n  height: 10px;\n  background: #FA7317;\n  border-radius: 50%;\n}\n\n/* Tipo de propiedad: chips Casas / PH / Departamentos / Otros */\n.property-type-options {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.65rem;\n}\n\n.property-type-option {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  min-width: 0;\n  padding: 0.75rem 0.9rem;\n  border-radius: 12px;\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  background: linear-gradient(155deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 247, 237, 0.7) 100%);\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);\n  color: #334155;\n  font-size: 0.92rem;\n  font-weight: 650;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n  user-select: none;\n}\n\n.property-type-option input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.property-type-option:hover {\n  border-color: rgba(250, 115, 23, 0.45);\n}\n\n.property-type-option--active {\n  border-color: #fa7317;\n  background: rgba(250, 115, 23, 0.1);\n  color: #c2410c;\n  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.12);\n}\n\n.property-type-other {\n  margin-top: 0.85rem;\n  padding: 0.85rem 0.9rem;\n  border-radius: 12px;\n  background: rgba(250, 115, 23, 0.05);\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n\n.property-type-other .wizard-field__label {\n  margin-bottom: 0.35rem;\n  text-transform: none;\n  letter-spacing: 0;\n  font-size: 0.82rem;\n  color: #475569;\n}\n\n.property-type-other__hint {\n  margin: 0.45rem 0 0;\n  font-size: 0.8rem;\n  line-height: 1.4;\n  color: #64748b;\n}\n\n.checkbox-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n}\n\n.amenities-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.85rem;\n  width: 100%;\n  max-width: 980px;\n  margin: 0 auto;\n}\n\n@media (max-width: 900px) {\n  .amenities-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.wizard-step--amenities .wizard-step__subtitle {\n  max-width: 36rem;\n}\n\n.amenity-option {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  min-height: 56px;\n  padding: 0.85rem 1rem;\n  border-radius: var(--app-radius, 12px);\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  background: linear-gradient(155deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 247, 237, 0.7) 100%);\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);\n  color: #334155;\n  font-size: 0.95rem;\n  font-weight: 650;\n  cursor: pointer;\n  user-select: none;\n  box-sizing: border-box;\n  transition:\n    border-color 0.15s ease,\n    box-shadow 0.15s ease,\n    background 0.15s ease,\n    color 0.15s ease;\n}\n\n.amenity-option:hover {\n  border-color: rgba(250, 115, 23, 0.35);\n  color: #0f172a;\n}\n\n.amenity-option.is-active {\n  border-color: #fa7317;\n  background: rgba(250, 115, 23, 0.1);\n  color: #c2410c;\n  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.12);\n}\n\n.amenity-option input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  margin: 0;\n  pointer-events: none;\n}\n\n.amenity-option__check {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  border: 1.5px solid rgba(15, 23, 42, 0.18);\n  border-radius: 4px;\n  background: rgba(248, 250, 252, 0.95);\n  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n  box-sizing: border-box;\n}\n\n.amenity-option.is-active .amenity-option__check,\n.amenity-option input[type=\"checkbox\"]:checked + .amenity-option__check {\n  background: #fa7317;\n  border-color: #fa7317;\n  box-shadow: 0 2px 6px rgba(250, 115, 23, 0.28);\n}\n\n.amenity-option.is-active .amenity-option__check::after,\n.amenity-option input[type=\"checkbox\"]:checked + .amenity-option__check::after {\n  content: \"\";\n  display: block;\n  width: 5px;\n  height: 10px;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg) translateY(-1px);\n}\n\n.amenity-option__label {\n  line-height: 1.2;\n}\n\n.amenity-option--cochera {\n  justify-content: space-between;\n  cursor: default;\n}\n\n.amenity-option__row {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  cursor: pointer;\n  flex: 1;\n  min-width: 0;\n}\n\n.amenity-option__stepper {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.15rem;\n  flex-shrink: 0;\n  padding: 3px;\n  border-radius: var(--app-radius, 12px);\n  background: rgba(15, 23, 42, 0.05);\n  border: 1px solid rgba(15, 23, 42, 0.06);\n}\n\n.amenity-option__stepper-btn {\n  appearance: none;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  margin: 0;\n  padding: 0;\n  border: none;\n  border-radius: var(--app-radius, 12px);\n  background: #fff;\n  color: #c2410c;\n  font-size: 0;\n  line-height: 0;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n  transition: background 0.15s ease, color 0.15s ease, opacity 0.15s ease;\n}\n\n.amenity-option__stepper-btn::before,\n.amenity-option__stepper-btn:last-child::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  background: currentColor;\n  border-radius: 1px;\n  transform: translate(-50%, -50%);\n}\n\n.amenity-option__stepper-btn::before {\n  width: 12px;\n  height: 2px;\n}\n\n.amenity-option__stepper-btn:last-child::after {\n  width: 2px;\n  height: 12px;\n}\n\n.amenity-option__stepper-btn:hover:not(:disabled) {\n  background: #fa7317;\n  color: #fff;\n}\n\n.amenity-option__stepper-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  color: #94a3b8;\n}\n\n.amenity-option__stepper-value {\n  min-width: 1.5rem;\n  padding: 0 0.2rem;\n  text-align: center;\n  font-size: 0.95rem;\n  font-weight: 750;\n  color: #0f172a;\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n}\n\n.p-button-secondary {\n  border-radius: var(--app-radius, 12px);\n}\n\n/* Legacy checkbox styles (por si quedan usos) */\n.checkbox-option {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: 16px;\n  color: #495057;\n  padding: 10px 12px;\n  min-height: 48px;\n  background: #f8f9fa;\n  border: 1px solid transparent;\n  border-radius: var(--app-radius, 12px);\n  transition: background 0.2s, border-color 0.2s;\n  box-sizing: border-box;\n}\n\n.checkbox-option:hover {\n  background: #e9ecef;\n}\n\n.checkbox-option input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  margin: 0;\n  pointer-events: none;\n}\n\n.checkbox-custom {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #adb5bd;\n  border-radius: 4px;\n  margin-right: 10px;\n  position: relative;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.checkbox-option input[type=\"checkbox\"]:checked + .checkbox-custom {\n  background: #FA7317;\n  border-color: #FA7317;\n}\n\n.checkbox-option input[type=\"checkbox\"]:checked + .checkbox-custom::after {\n  content: '';\n  display: block;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg) translateY(-1px);\n}\n\n.checkbox-option--cochera {\n  justify-content: space-between;\n  gap: 0.5rem;\n  cursor: default;\n}\n\n.checkbox-option--cochera.is-active {\n  border-color: rgba(250, 115, 23, 0.35);\n}\n\n.checkbox-option__row {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  flex: 1;\n  min-width: 0;\n}\n\n.checkbox-option__quantity {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex-shrink: 0;\n}\n\n.checkbox-option__quantity-label {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #6b7280;\n  white-space: nowrap;\n}\n\n.checkbox-option__quantity-input {\n  width: 56px;\n  padding: 6px 8px;\n  border: 1px solid rgba(250, 115, 23, 0.5);\n  border-radius: var(--app-radius, 12px);\n  font-size: 15px;\n  text-align: center;\n  color: #343a40;\n  background: #fff;\n  box-sizing: border-box;\n  -moz-appearance: textfield;\n}\n\n.checkbox-option__quantity-input::-webkit-outer-spin-button,\n.checkbox-option__quantity-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.checkbox-option__quantity-input:focus {\n  outline: none;\n  border-color: #FA7317;\n  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.12);\n}\n\n.characteristic-field {\n  --cf-radius: 12px;\n  margin-bottom: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  padding: 0.95rem 1rem 1rem;\n  border-radius: var(--cf-radius);\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  background: linear-gradient(155deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 247, 237, 0.7) 100%);\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);\n  transition:\n    border-color 0.18s ease,\n    box-shadow 0.18s ease,\n    background 0.18s ease;\n}\n\n.characteristic-field:hover {\n  border-color: rgba(250, 115, 23, 0.22);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.95) inset,\n    0 10px 24px rgba(15, 23, 42, 0.06);\n}\n\n.characteristic-field:focus-within {\n  border-color: rgba(250, 115, 23, 0.5);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.95) inset,\n    0 0 0 3px rgba(250, 115, 23, 0.12),\n    0 12px 28px rgba(250, 115, 23, 0.08);\n}\n\n.characteristic-field__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.65rem;\n  min-height: 28px;\n}\n\n.characteristic-field__label {\n  display: block;\n  margin: 0;\n  color: #475569;\n  font-size: 0.72rem;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1.2;\n}\n\n.characteristic-field__mode {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px;\n  border-radius: var(--app-radius, 12px);\n  background: rgba(15, 23, 42, 0.06);\n  border: 1px solid rgba(15, 23, 42, 0.05);\n  flex-shrink: 0;\n}\n\n.characteristic-field__mode-btn {\n  appearance: none;\n  border: none;\n  background: transparent;\n  margin: 0;\n  padding: 0.28rem 0.55rem;\n  border-radius: var(--app-radius, 12px);\n  color: #64748b;\n  font: inherit;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.characteristic-field__mode-btn:hover {\n  color: #0f172a;\n}\n\n.characteristic-field__mode-btn.is-active {\n  background: #fff;\n  color: #c2410c;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.1);\n}\n\n.characteristic-field--range .characteristic-field__mode-btn.is-active {\n  background: #fa7317;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(250, 115, 23, 0.28);\n}\n\n.characteristic-field__control {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  flex: 1;\n}\n\n.characteristic-field__input {\n  width: 100%;\n  min-height: 52px;\n  margin: 0;\n  padding: 14px 16px;\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  border-radius: 12px;\n  background: #fff;\n  color: #0f172a;\n  font: inherit;\n  font-size: 1.2rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n  -moz-appearance: textfield;\n}\n\n.characteristic-field__input::-webkit-outer-spin-button,\n.characteristic-field__input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.characteristic-field__input::placeholder {\n  color: #94a3b8;\n  font-weight: 550;\n  letter-spacing: 0;\n  font-size: 0.95rem;\n}\n\n.characteristic-field__input:hover {\n  border-color: rgba(250, 115, 23, 0.28);\n  background: #fff;\n}\n\n.characteristic-field__input:focus {\n  outline: none;\n  border-color: #fa7317;\n  background: #fff;\n  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.15);\n}\n\n.characteristic-field__chip {\n  display: none;\n}\n\n.characteristic-field__range .characteristic-field__input {\n  padding: 0.7rem 0.75rem;\n  font-size: 1.1rem;\n  text-align: center;\n  min-height: 52px;\n}\n\n.characteristic-field__range {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n}\n\n.characteristic-field__separator {\n  color: #cbd5e1;\n  font-weight: 600;\n  font-size: 1rem;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.characteristics-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 1rem 1.1rem;\n  width: 100%;\n  max-width: 980px;\n  margin: 0 auto;\n}\n\n.characteristics-grid .characteristic-field:nth-child(-n + 3) {\n  grid-column: span 2;\n}\n\n.characteristics-grid .characteristic-field:nth-child(4),\n.characteristics-grid .characteristic-field:nth-child(5) {\n  grid-column: span 3;\n}\n\n.characteristics-grid.characteristics-grid--single .characteristic-field:nth-child(n) {\n  grid-column: 3 / span 2;\n}\n\n.wizard-step--characteristics .wizard-step__subtitle {\n  max-width: 42rem;\n}\n\n.wizard-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 28px;\n  padding-top: 18px;\n  border-top: 1px solid #e9ecef;\n}\n\n.wizard-footer__back,\n.wizard-footer__forward {\n  display: flex;\n  align-items: center;\n}\n\n.wizard-footer__back:empty {\n  display: none;\n}\n\n.wizard-footer__back {\n  justify-content: flex-start;\n}\n\n.wizard-footer__forward {\n  margin-left: auto;\n  justify-content: flex-end;\n}\n\n.wizard-footer__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  margin: 0;\n  min-height: 44px;\n  padding: 0.7rem 1.2rem;\n  border-radius: var(--app-radius, 12px);\n  font-weight: 600;\n  font-size: 0.95rem;\n  line-height: 1.2;\n  box-sizing: border-box;\n}\n\n.wizard-footer .details-button.wizard-footer__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  width: auto;\n  max-width: none;\n  margin: 0;\n  padding: 0.7rem 1.2rem;\n  border-radius: var(--app-radius, 12px);\n}\n\n.wizard-footer .details-button {\n  margin-top: 0;\n  margin-right: 0;\n}\n\n.wizard-footer .wizard-footer__btn,\n.wizard-footer .details-button.wizard-footer__btn,\n.wizard-footer .p-button-secondary.wizard-footer__btn {\n  border: none;\n  background: linear-gradient(135deg, #fa7317 0%, #c2410c 100%);\n  color: #fff;\n  box-shadow: 0 4px 12px rgba(250, 115, 23, 0.25);\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.wizard-footer .wizard-footer__btn:hover,\n.wizard-footer .details-button.wizard-footer__btn:hover,\n.wizard-footer .p-button-secondary.wizard-footer__btn:hover {\n  transform: translateY(-1px);\n  background: linear-gradient(135deg, #fa7317 0%, #c2410c 100%);\n  color: #fff;\n  box-shadow: 0 6px 18px rgba(250, 115, 23, 0.35);\n}\n\n.wizard-footer .wizard-footer__btn:disabled {\n  opacity: 0.55;\n  transform: none;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.wizard-footer__btn span {\n  line-height: 1.2;\n}\n\n.wizard-footer__btn .pi {\n  font-size: 0.8rem;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.wizard-footer__btn--next .pi {\n  margin-left: 0.1rem;\n}\n\n/* ---------- Tablet ---------- */\n@media (max-width: 1024px) {\n  .property-wizard-container {\n    max-width: 960px;\n  }\n  .checkbox-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* ---------- Mobile ---------- */\n@media (max-width: 768px) {\n  .property-form-page {\n    padding: 16px 12px;\n    align-items: center;\n  }\n\n  .property-form-page__logo {\n    height: 48px;\n  }\n\n  .property-form-page .property-wizard-container {\n    min-height: auto;\n    margin: 0 auto;\n    border-radius: var(--app-radius, 12px);\n    box-shadow:\n      0 1px 0 rgba(255, 255, 255, 0.8) inset,\n      0 10px 36px rgba(15, 23, 42, 0.08);\n    padding: 16px;\n    padding-bottom: 20px;\n    background: rgba(255, 255, 255, 0.82);\n    backdrop-filter: blur(18px) saturate(1.2);\n    -webkit-backdrop-filter: blur(18px) saturate(1.2);\n  }\n\n  .wizard-modal {\n    padding: 0;\n    align-items: stretch;\n  }\n\n  .property-wizard-container {\n    max-width: 100%;\n    margin: 0;\n    min-height: 100dvh;       /* garantiza altura completa en mobile */\n    border-radius: 0;\n    padding: 16px;\n    padding-bottom: 96px;     /* deja lugar para el footer sticky */\n    box-shadow: none;\n  }\n\n  .wizard-header {\n    margin-bottom: 20px;\n  }\n\n  .wizard-step h2,\n  .wizard-step__title {\n    font-size: 1.3rem;\n  }\n\n  .subtitle,\n  .wizard-step__subtitle {\n    font-size: 0.92rem;\n    margin-bottom: 1.15rem;\n  }\n\n  .wizard-step--location .wizard-step__body {\n    gap: 1.05rem;\n  }\n\n  .operation-options {\n    grid-template-columns: 1fr;\n  }\n\n  .operation-option,\n  .property-type-option {\n    min-height: 46px;\n    font-size: 0.9rem;\n  }\n\n  .checkbox-grid,\n  .amenities-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 0.7rem;\n  }\n\n  .amenity-option {\n    min-height: 52px;\n    padding: 0.75rem 0.85rem;\n    font-size: 0.9rem;\n  }\n\n  .amenity-option--cochera {\n    grid-column: 1 / -1;\n  }\n\n  .characteristic-field {\n    padding: 0.8rem 0.85rem 0.9rem;\n    gap: 0.55rem;\n  }\n\n  .characteristic-field__input {\n    min-height: 48px;\n    font-size: 1.1rem;\n  }\n\n  .characteristic-field__mode-btn {\n    padding: 0.3rem 0.48rem;\n    font-size: 0.66rem;\n  }\n\n  .characteristic-field__range .characteristic-field__input {\n    padding: 0.65rem 0.55rem;\n    font-size: 1rem;\n    min-height: 48px;\n  }\n\n  .characteristics-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 0.75rem;\n    max-width: none;\n  }\n\n  .characteristics-grid .characteristic-field:nth-child(-n + 5) {\n    grid-column: auto;\n  }\n\n  .characteristics-grid--single {\n    grid-template-columns: 1fr;\n    max-width: 420px;\n  }\n\n  .characteristics-grid.characteristics-grid--single .characteristic-field:nth-child(n) {\n    grid-column: auto;\n  }\n\n  .radio-group {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .wizard-input,\n  select.wizard-input,\n  input.wizard-input {\n    font-size: 16px;           /* 16px evita el zoom en iOS */\n    padding: 10px 12px;\n  }\n\n  select.wizard-input {\n    padding-right: 36px;\n  }\n\n  /* Footer sticky para que los botones queden siempre a la vista */\n  .wizard-footer {\n    position: sticky;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    flex-direction: row;\n    gap: 10px;\n    margin-top: 20px;\n    padding: 12px 16px;\n    background: #fff;\n    border-top: 1px solid #e9ecef;\n    box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.05);\n    /* anular el margin horizontal del container para que llene el ancho */\n    margin-left: -16px;\n    margin-right: -16px;\n  }\n\n  .property-form-page .wizard-footer {\n    position: static;\n    margin: 20px 0 0;\n    padding: 16px 0 0;\n    background: transparent;\n    box-shadow: none;\n  }\n\n  .wizard-footer__btn {\n    padding: 12px;\n    font-size: 15px;\n  }\n\n  .wizard-footer__back:not(:empty) .wizard-footer__btn,\n  .wizard-footer__back:not(:empty) + .wizard-footer__forward .wizard-footer__btn {\n    flex: 1;\n  }\n\n  .wizard-top-bar {\n    gap: 0.5rem;\n  }\n\n  .credit-badge__credits {\n    font-size: 0.72rem;\n    white-space: normal;\n    text-align: right;\n  }\n}\n\n/* ---------- Mobile chico ---------- */\n@media (max-width: 480px) {\n  .checkbox-grid,\n  .amenities-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .characteristics-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.wizard-guide {\n  display: grid;\n  grid-template-columns: minmax(0, 1.1fr) minmax(230px, 0.9fr);\n  gap: 14px;\n  margin: 0 0 22px;\n  padding: 14px;\n  background: #f8fafc;\n  border: 1px solid #c7d2fe;\n  border-left: 4px solid #4f46e5;\n  border-radius: var(--app-radius, 12px);\n  text-align: left;\n}\n\n.wizard-guide__main {\n  display: flex;\n  gap: 12px;\n  min-width: 0;\n}\n\n.wizard-guide__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 40px;\n  width: 40px;\n  height: 40px;\n  border-radius: var(--app-radius, 12px);\n  color: #c2410c;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n}\n\n.wizard-guide__eyebrow {\n  margin: 0 0 2px;\n  color: #4338ca;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0;\n  text-transform: uppercase;\n}\n\n.wizard-guide h2 {\n  margin: 0 0 4px;\n  color: #1f2937;\n  font-size: 1rem;\n  line-height: 1.25;\n  text-align: left;\n}\n\n.wizard-guide__main p:not(.wizard-guide__eyebrow) {\n  margin: 0;\n  color: #374151;\n  font-size: 0.9rem;\n  line-height: 1.45;\n}\n\n.wizard-guide__steps {\n  margin: 0;\n  padding-left: 1.2rem;\n  color: #4b5563;\n  font-size: 0.86rem;\n  line-height: 1.45;\n}\n\n.wizard-guide__steps li + li {\n  margin-top: 0.25rem;\n}\n\n.wizard-guide__tip {\n  grid-column: 1 / -1;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid #e2e8f0;\n  color: #0f766e;\n  font-size: 0.84rem;\n  line-height: 1.4;\n}\n\n@media (max-width: 768px) {\n  .wizard-guide {\n    grid-template-columns: 1fr;\n    gap: 10px;\n    margin-bottom: 18px;\n    padding: 12px;\n  }\n\n  .wizard-guide h2 {\n    font-size: 0.96rem;\n  }\n\n  .wizard-guide__steps {\n    font-size: 0.84rem;\n  }\n}\n/* property-form-scroll-fix: /property-form vive fuera del modal y necesita su propio scroll. */\n.property-form-page .property-wizard-container {\n  max-height: calc(100vh - 120px);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-gutter: stable;\n  padding-bottom: 20px;\n}\n\n@supports (height: 100dvh) {\n  .property-form-page .property-wizard-container {\n    max-height: calc(100dvh - 120px);\n  }\n}\n\n.property-form-page .wizard-header {\n  margin-bottom: 14px;\n}\n\n.property-form-page .wizard-guide {\n  gap: 10px;\n  margin-bottom: 14px;\n  padding: 12px;\n}\n\n.property-form-page .wizard-guide__main p:not(.wizard-guide__eyebrow) {\n  font-size: 0.84rem;\n  line-height: 1.35;\n}\n\n.property-form-page .wizard-guide__steps {\n  font-size: 0.8rem;\n  line-height: 1.35;\n}\n\n.property-form-page .wizard-guide__tip {\n  padding-top: 0.55rem;\n  font-size: 0.78rem;\n  line-height: 1.35;\n}\n\n.property-form-page .wizard-footer {\n  position: static;\n  margin: 24px 0 0;\n  padding: 18px 0 0;\n  background: transparent;\n  box-shadow: none;\n  border-top: 1px solid #e9ecef;\n}\n\n/* Paso 2: la página vuelve a scrollear cuando el mapa no entra en la pantalla. */\n.property-form-page:has(.property-wizard-container--fit) {\n  height: auto;\n  max-height: none;\n  overflow: visible;\n  justify-content: safe center;\n}\n\n.property-form-page .property-wizard-container--fit {\n  flex: 0 1 auto;\n  min-height: 0;\n  max-height: none;\n  overflow: visible;\n  display: flex;\n  flex-direction: column;\n  scrollbar-gutter: auto;\n  padding-bottom: 14px;\n}\n\n.property-wizard-container--fit .wizard-top-bar,\n.property-wizard-container--fit .wizard-header,\n.property-wizard-container--fit .wizard-footer {\n  flex-shrink: 0;\n}\n\n.property-wizard-container--fit .wizard-header {\n  margin-bottom: 8px;\n}\n\n.property-wizard-container--fit .wizard-footer {\n  margin-top: 12px;\n  padding-top: 12px;\n}\n\n.property-wizard-container--fit .wizard-content {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.property-wizard-container--fit .wizard-step--zone {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.property-wizard-container--fit .wizard-step--zone .wizard-step__intro {\n  flex-shrink: 0;\n}\n\n.property-wizard-container--fit .wizard-step--zone > .map-preview-modal--embedded {\n  flex: none;\n  min-height: 0;\n  height: auto;\n}\n\n.property-wizard-container--fit .wizard-step--zone .map-preview-card {\n  flex: none;\n  height: auto;\n  min-height: 0;\n  overflow: visible;\n}\n\n@media (min-width: 769px) and (max-height: 900px) {\n  .property-form-page {\n    gap: 0.75rem;\n    padding-top: 12px;\n    padding-bottom: 12px;\n  }\n\n  .property-form-page__logo {\n    height: 48px;\n  }\n\n  .property-form-page .property-wizard-container {\n    max-width: 1480px;\n    max-height: calc(100vh - 100px);\n    padding: 14px 16px 16px;\n  }\n\n  @supports (height: 100dvh) {\n    .property-form-page .property-wizard-container {\n      max-height: calc(100dvh - 68px);\n    }\n  }\n\n  .property-form-page .wizard-top-bar {\n    padding-bottom: 0.35rem;\n  }\n\n  .property-form-page .credit-badge__greeting {\n    font-size: 1.05rem;\n  }\n\n  .property-form-page .credit-badge__credits {\n    font-size: 0.76rem;\n  }\n\n  .property-form-page .wizard-header {\n    margin-bottom: 10px;\n  }\n\n  .property-form-page .progress-bar {\n    height: 6px;\n    margin-bottom: 6px;\n  }\n\n  .property-form-page .step-indicator {\n    font-size: 12px;\n  }\n\n  .property-form-page .wizard-guide {\n    gap: 8px;\n    margin-bottom: 10px;\n    padding: 10px;\n  }\n\n  .property-form-page .wizard-guide__icon {\n    flex-basis: 34px;\n    width: 34px;\n    height: 34px;\n  }\n\n  .property-form-page .wizard-guide h2 {\n    font-size: 0.92rem;\n  }\n\n  .property-form-page .wizard-guide__main p:not(.wizard-guide__eyebrow) {\n    font-size: 0.78rem;\n    line-height: 1.28;\n  }\n\n  .property-form-page .wizard-guide__steps {\n    font-size: 0.74rem;\n    line-height: 1.3;\n  }\n\n  .property-form-page .wizard-guide__tip {\n    font-size: 0.72rem;\n    line-height: 1.28;\n  }\n\n  .property-form-page .wizard-step h2 {\n    font-size: 20px;\n    margin-bottom: 4px;\n  }\n\n  .property-form-page .subtitle {\n    font-size: 14px;\n    margin-bottom: 12px;\n  }\n\n  .property-form-page .input-group,\n  .property-form-page .form-section {\n    margin-bottom: 12px;\n  }\n\n  .property-form-page .characteristics-grid,\n  .property-form-page .amenities-grid {\n    gap: 12px;\n  }\n\n  .property-form-page .wizard-footer {\n    margin: 16px 0 0;\n    padding: 14px 0 0;\n  }\n}\n\n@media (min-width: 769px) and (max-height: 760px) {\n  .property-form-page .property-wizard-container {\n    max-width: 1480px;\n    padding: 12px 14px 14px;\n  }\n\n  .property-form-page .wizard-guide {\n    grid-template-columns: 1fr;\n    gap: 7px;\n    padding: 9px;\n  }\n\n  .property-form-page .wizard-guide__steps {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 6px;\n    padding-left: 0;\n    list-style-position: inside;\n  }\n\n  .property-form-page .wizard-guide__steps li + li {\n    margin-top: 0;\n  }\n\n  .property-form-page .wizard-guide__tip {\n    display: none;\n  }\n}\n\n@media (min-width: 769px) and (max-height: 660px) {\n  .property-form-page .wizard-guide__steps {\n    display: none;\n  }\n\n  .property-form-page .wizard-footer__btn {\n    padding: 9px 12px;\n    font-size: 13px;\n  }\n}\n\n/* Paso del mapa en monitores bajos: compactar el marco para que el mapa\n   y los controles quepan, sin recortar el contenido. */\n@media (min-width: 769px) and (max-height: 720px) {\n  .property-form-page:has(.property-wizard-container--fit) {\n    gap: 0.4rem;\n    padding-top: 8px;\n    padding-bottom: 8px;\n  }\n\n  .property-form-page:has(.property-wizard-container--fit) .property-form-page__logo {\n    height: 36px;\n  }\n\n  .property-form-page .property-wizard-container--fit {\n    padding: 10px 14px 10px;\n  }\n\n  .property-wizard-container--fit .wizard-header {\n    margin-bottom: 4px;\n  }\n\n  .property-wizard-container--fit .wizard-step--zone .wizard-step__title {\n    margin-bottom: 0.15rem;\n    font-size: 1.25rem;\n  }\n\n  .property-wizard-container--fit .wizard-step--zone .wizard-step__subtitle {\n    font-size: 0.84rem;\n    line-height: 1.3;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n\n  .property-wizard-container--fit .wizard-footer {\n    margin-top: 8px;\n    padding-top: 8px;\n  }\n\n  .property-form-page:has(.property-wizard-container--fit) > .wizard-help-trigger {\n    padding-top: 0;\n    padding-bottom: 0;\n    font-size: 0.84rem;\n  }\n}\n\n.property-form-page .property-wizard-container.property-wizard-container--fit {\n  max-height: none;\n  overflow: visible;\n}\n/* wizard-modal-scroll-fix: el instructivo no debe tapar los botones del modal. */\n.wizard-modal {\n  overflow: hidden;\n  padding: 16px;\n}\n\n.wizard-modal .property-wizard-container {\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-gutter: stable;\n}\n\n@supports (height: 100dvh) {\n  .wizard-modal .property-wizard-container {\n    max-height: calc(100dvh - 32px);\n  }\n}\n\n.wizard-modal .wizard-header {\n  margin-bottom: 14px;\n}\n\n.wizard-modal .wizard-guide {\n  gap: 10px;\n  margin-bottom: 14px;\n  padding: 12px;\n}\n\n.wizard-modal .wizard-guide__main p:not(.wizard-guide__eyebrow) {\n  font-size: 0.84rem;\n  line-height: 1.35;\n}\n\n.wizard-modal .wizard-guide__steps {\n  font-size: 0.8rem;\n  line-height: 1.35;\n}\n\n.wizard-modal .wizard-guide__tip {\n  padding-top: 0.55rem;\n  font-size: 0.78rem;\n  line-height: 1.35;\n}\n\n.wizard-modal .wizard-footer {\n  position: sticky;\n  bottom: 0;\n  z-index: 8;\n  margin: 18px -20px -20px;\n  padding: 12px 20px;\n  background: #fff;\n  box-shadow: 0 -4px 12px rgba(15, 23, 42, 0.08);\n}\n\n@media (min-width: 769px) and (max-height: 860px) {\n  .wizard-modal {\n    padding: 10px;\n  }\n\n  .wizard-modal .property-wizard-container {\n    max-width: 1040px;\n    max-height: calc(100vh - 20px);\n    padding: 14px 16px 0;\n  }\n\n  @supports (height: 100dvh) {\n    .wizard-modal .property-wizard-container {\n      max-height: calc(100dvh - 20px);\n    }\n  }\n\n  .wizard-modal .wizard-top-bar {\n    padding-bottom: 0.35rem;\n  }\n\n  .wizard-modal .credit-badge__greeting {\n    font-size: 1.05rem;\n  }\n\n  .wizard-modal .credit-badge__credits {\n    font-size: 0.76rem;\n  }\n\n  .wizard-modal .wizard-header {\n    margin-bottom: 10px;\n  }\n\n  .wizard-modal .progress-bar {\n    height: 6px;\n    margin-bottom: 6px;\n  }\n\n  .wizard-modal .step-indicator {\n    font-size: 12px;\n  }\n\n  .wizard-modal .wizard-guide {\n    gap: 8px;\n    margin-bottom: 10px;\n    padding: 10px;\n  }\n\n  .wizard-modal .wizard-guide__main {\n    gap: 9px;\n  }\n\n  .wizard-modal .wizard-guide__icon {\n    flex-basis: 34px;\n    width: 34px;\n    height: 34px;\n  }\n\n  .wizard-modal .wizard-guide h2 {\n    font-size: 0.92rem;\n  }\n\n  .wizard-modal .wizard-guide__main p:not(.wizard-guide__eyebrow) {\n    font-size: 0.78rem;\n    line-height: 1.28;\n  }\n\n  .wizard-modal .wizard-guide__steps {\n    font-size: 0.74rem;\n    line-height: 1.3;\n  }\n\n  .wizard-modal .wizard-guide__tip {\n    font-size: 0.72rem;\n    line-height: 1.28;\n  }\n\n  .wizard-modal .wizard-step h2 {\n    font-size: 20px;\n    margin-bottom: 4px;\n  }\n\n  .wizard-modal .subtitle {\n    font-size: 14px;\n    margin-bottom: 12px;\n  }\n\n  .wizard-modal .input-group,\n  .wizard-modal .form-section {\n    margin-bottom: 12px;\n  }\n\n  .wizard-modal .characteristics-grid,\n  .wizard-modal .amenities-grid {\n    gap: 12px;\n  }\n\n  .wizard-modal .wizard-footer {\n    margin: 12px -16px 0;\n    padding: 10px 16px;\n  }\n}\n\n@media (min-width: 769px) and (max-height: 760px) {\n  .wizard-modal .property-wizard-container {\n    max-width: 1000px;\n    padding: 12px 14px 0;\n  }\n\n  .wizard-modal .wizard-guide {\n    grid-template-columns: 1fr;\n    gap: 7px;\n    padding: 9px;\n  }\n\n  .wizard-modal .wizard-guide__steps {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 6px;\n    padding-left: 0;\n    list-style-position: inside;\n  }\n\n  .wizard-modal .wizard-guide__steps li + li {\n    margin-top: 0;\n  }\n\n  .wizard-modal .wizard-guide__tip {\n    display: none;\n  }\n\n  .wizard-modal .wizard-step h2 {\n    font-size: 18px;\n  }\n\n  .wizard-modal .subtitle {\n    font-size: 13px;\n    margin-bottom: 10px;\n  }\n}\n\n@media (min-width: 769px) and (max-height: 660px) {\n  .wizard-modal .wizard-guide__steps {\n    display: none;\n  }\n\n  .wizard-modal .wizard-guide__main p:not(.wizard-guide__eyebrow) {\n    font-size: 0.76rem;\n  }\n\n  .wizard-modal .wizard-header {\n    margin-bottom: 8px;\n  }\n\n  .wizard-modal .wizard-footer__btn {\n    padding: 9px 12px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 768px) {\n  .wizard-modal {\n    padding: 0;\n  }\n\n  .wizard-modal .property-wizard-container {\n    height: 100vh;\n    max-height: 100vh;\n    padding-bottom: 0;\n  }\n\n  @supports (height: 100dvh) {\n    .wizard-modal .property-wizard-container {\n      height: 100dvh;\n      max-height: 100dvh;\n    }\n  }\n\n  .wizard-modal .wizard-guide {\n    gap: 8px;\n    margin-bottom: 12px;\n    padding: 10px;\n  }\n\n  .wizard-modal .wizard-guide__tip {\n    display: none;\n  }\n\n  .wizard-modal .wizard-footer {\n    margin: 18px -16px 0;\n    padding: 12px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
